/**
 * @param {string|number|null|undefined} value
 * @returns {string|null}
 */
export const toDisplayablePhone = (value) => (
  value && !/^[a-z]+:/i.test(String(value)) ? String(value) : null
);

/**
 * @param {import('src/type-defs/five9Types').Five9Call|null|undefined} call
 * @returns {string|null}
 */
export default function getCallDisplayNumber(call) {
  if (!call) return null;

  const direction = String(call.direction ?? '').toUpperCase();
  const ordered = direction === 'OUTBOUND'
    ? [call.dnis, call.number, call.phoneNumber, call.ani]
    : [call.ani, call.number, call.phoneNumber, call.dnis];

  return ordered.map(toDisplayablePhone).find(Boolean) ?? null;
}

const WRAP_UP_STATES = ['ENDED', 'WRAP_UP'];

/**
 * @param {import('src/type-defs/five9Types').Five9Call|null|undefined} call
 * @returns {boolean}
 */
export const isCallInWrapUp = (call) => Boolean(
  call && (call.endedAt || WRAP_UP_STATES.includes(call.callState || call.state))
);
